import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AvatarModule } from 'primeng/avatar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fingerprint-error',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule, AvatarModule],
  templateUrl: './fingerprint-error.component.html',
  styleUrl: './fingerprint-error.component.scss'
})
export class FingerprintErrorComponent {
  constructor(private router: Router) {}

  retryScan(): void {
    // Navigate back to scanner
    this.router.navigate(['/scanner']);
  }

  goHome(): void {
    // Navigate to home page
    this.router.navigate(['/']);
  }

  getHelp(): void {
    // Open help or contact page
    window.open('mailto:support@example.com', '_blank');
  }
}
